module.exports = __webpack_public_path__ + "img/transition_arrow.6bbe62ca.svg";